module.exports = __webpack_public_path__ + "img/pig5.5fa70e3e.png";